// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9s1sh","title":"styles_title__2t3gY","FormWrapper":"styles_FormWrapper__1jkjl","map":"styles_map__1-dA7","phoneWrapper":"styles_phoneWrapper__Bi6qQ"};